<template>
  <div class="text-center">
    <img
      src="https://admisionlogos.s3.amazonaws.com/registro-vue/cargador-logo-sistema-de-admision.png"
      class="img-fluid mt-1 mb-2 mt-lg-2"
      alt
    />
  </div>
</template>
<script>
import { manejoErrores } from "@/assets/js/manejoErrores";
export default {
  mixins: [manejoErrores],
  components: {},
  data() {
    return {
      usuario: {
        run: "",
        clave: ""
      },
      config: {
        headers: {},
        params: {}
      },
      siteKey: RECAPTCHA_PUBLIC_KEY,
      rut: "",
      errorRut: false,
      errorPass: false,
      tiempoToken: 15 * 60 * 1000,
      ayuda: PLATAFORMA.AYUDA,
      etapaProceso: null
    };
  },
  created() {
    this.fetchData();
  },
  mounted: function() {
    this.guardarSession();
  },
  methods: {
    async fetchData() {
      try {
        const tokenBearer =
          "eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJhZG1pc2lvbi1lc2NvbGFyIiwiaWF0IjoxNzQ4ODgxNDE0LCJleHAiOjE3ODA0MTc0MTQsImlkUG9zdHVsYWNpb24iOiI2ODNkYmZhODhiYmZmMzAwMDE5YWY1ZmYiLCJpc0FkbWluIjpmYWxzZX0.3AztlB-nsLnr-Pe2-mzyo3gzRaEAowUZq2-VeumajHE";
        const etapaValor = await ApiDirectorio.obtenerInformacion(
          this,
          tokenBearer
        );
        if (etapaValor) {
          this.etapaProceso = etapaValor;
        } else {
          console.error("No se obtuvo la etapa correctamente.");
        }
      } catch (error) {
        console.error("Error al cargar la etapa:", error);
      }
    },
    async guardarSession() {
      this.$emit("cargar");
      this.$ss.set("jwt", this.$route.query.token, this.tiempoToken);
      this.$ss.set("claveunica", true, this.tiempoToken);
      this.$ss.set("esClaveSegura", true, this.tiempoToken);
      setTimeout(() => (this.isHidden = false), 5000);

      if (
        this.etapaProceso === "POSTULACION" ||
        this.etapaProceso === "COMPLEMENTARIO" ||
        this.etapaProceso === "REGISTRO_ANTICIPADO"
      ) {
        this.$router.push({ name: "Postulacion" });
      } else if (
        this.etapaProceso === "NORMAL" ||
        this.etapaProceso === "LISTA_DE_ESPERA" ||
        this.etapaProceso === "RESULTADO_FINAL"
      ) {
        this.$router.push({ name: "Resultados" });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/ClaveUnica.vue